module.exports = __webpack_public_path__ + "img/ATRC Platform - Website TCs-09.6857ad16.png";